/**
 * 通用页面头(带返回键)
 *
 * 用法:
 *   <PageHeader title="用户增长中心" subtitle="..." onBack={() => navigate(-1)} />
 *   <PageHeader title="实战分析" backTo="/tools" />  ← 跳到指定页
 */
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';

export default function PageHeader({ title, subtitle, onBack, backTo, icon: Icon, right, className }) {
  const navigate = useNavigate();
  const handleBack = () => {
    if (onBack) return onBack();
    if (backTo) return navigate(backTo);
    if (window.history.length > 1) return navigate(-1);
    return navigate('/');
  };
  return (
    <header className={clsx('flex items-center gap-2', className)}>
      <button
        onClick={handleBack}
        className="w-9 h-9 -ml-1 rounded-lg flex items-center justify-center text-ink-1 hover:bg-white/5 active:bg-white/10 transition flex-shrink-0"
        aria-label="返回"
      >
        <ChevronLeft size={22} />
      </button>
      <div className="flex-1 min-w-0 flex items-center gap-2">
        {Icon && <Icon size={20} className="text-brand-cyan flex-shrink-0" />}
        <div className="min-w-0 flex-1">
          <h1 className="text-lg font-bold truncate" style={{ color: 'var(--ink-0)' }}>{title}</h1>
          {subtitle && <p className="text-[10px] truncate" style={{ color: 'var(--ink-2)' }}>{subtitle}</p>}
        </div>
      </div>
      {right && <div className="flex-shrink-0">{right}</div>}
    </header>
  );
}
